<template>
    <b-row class="h-100 align-items-center">
        <b-col class="mx-auto" sm="6">
            <b-col class="text-center">
                <div class="sombra">
                    <Alerta
                        :variant="'info'"
                        :texto="`<h5>Desculpe, este atendimento encontra-se expirado.</h5>`"
                        :icone="'fa fa-exclamation-circle'"
                    />
                </div>
            </b-col>
        </b-col>
    </b-row>
</template>
<script>
import Alerta from "@/components/Alertas/Alerta.vue";
export default {
    components: {
        Alerta
    }
};
</script>
